import { IComponent } from "../../../models/Interfaces";

export const GRID_DROP_ID_PREFIX = "grid-drop";
export const COLUMN_DROP_ID_PREFIX = "column-drop";
export const SIDEBAR_COMPONENT_ID_PREFIX = "sidebar-component";

export interface IDragPointer {
  x: number;
  y: number;
}

export interface ISidebarDragData {
  component: IComponent;
  type: "NEW_COMPONENT";
}

export const getSidebarComponentDragId = (componentId: number): string =>
  `${SIDEBAR_COMPONENT_ID_PREFIX}-${componentId}`;

export const getGridDropId = (sectionId: number): string =>
  `${GRID_DROP_ID_PREFIX}-${sectionId}`;

export const getColumnDropId = (sectionId: number, columnIndex: number): string =>
  `${COLUMN_DROP_ID_PREFIX}-${sectionId}-${columnIndex}`;

export const parseGridDropId = (dropId: string): number | null => {
  const match = dropId.match(/^grid-drop-(\d+)$/);
  return match ? Number(match[1]) : null;
};

export const parseColumnDropId = (dropId: string): { sectionId: number; columnIndex: number } | null => {
  const match = dropId.match(/^column-drop-(\d+)-(\d+)$/);

  if (!match) {
    return null;
  }

  return {
    sectionId: Number(match[1]),
    columnIndex: Number(match[2])
  };
};
